import { createContext, useContext, useState } from 'react'
import type { Installment, PaymentSystem } from '~/type/Cart'

type CreditCardContextProps = {
  accountId: string
  setAccountId: (setAccountId: string) => void
  hasBeenAddedNewCard: boolean
  setHasBeenAddedNewCard: (isAdding: boolean) => void
  dueDate: { year: string; month: string; isValid: boolean }
  setDueDate: (props: { year: string; month: string; isValid: boolean }) => void
  cardNumber: string
  setCardNumber: (cardNumber: string) => void
  validationCode: string
  setValidationCode: (cvv: string) => void
  holderName: string
  setHolderName: (name: string) => void
  bin: string
  setBin: (bin: string) => void
  cpf: string
  setCpf: (cpf: string) => void
  installmentsSelected: Installment | null
  setInstallmentsSelected: (installment: Installment) => void
  setCreditCard: (creditCard: PaymentSystem | null) => void
  creditCard: PaymentSystem | null
}

export const CreditCardContext = createContext<CreditCardContextProps>({} as CreditCardContextProps)

export const PaymentCardProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hasBeenAddedNewCard, setHasBeenAddedNewCard] = useState(false)
  const [dueDate, setDueDate] = useState({ year: '', month: '', isValid: false })
  const [accountId, setAccountId] = useState('')
  const [cardNumber, setCardNumber] = useState('')
  const [validationCode, setValidationCode] = useState('')
  const [holderName, setHolderName] = useState('')
  const [bin, setBin] = useState('')
  const [cpf, setCpf] = useState('')
  const [installmentsSelected, setInstallmentsSelected] = useState<Installment | null>(null)
  const [creditCard, setCreditCard] = useState<PaymentSystem | null>(null)

  return (
    <CreditCardContext.Provider
      value={{
        accountId,
        setAccountId,
        hasBeenAddedNewCard,
        setHasBeenAddedNewCard,
        dueDate,
        setDueDate,
        cardNumber,
        setCardNumber,
        validationCode,
        setValidationCode,
        holderName,
        setHolderName,
        bin,
        setBin,
        cpf,
        setCpf,
        installmentsSelected,
        setInstallmentsSelected,
        setCreditCard,
        creditCard,
      }}
    >
      {children}
    </CreditCardContext.Provider>
  )
}

export const useCreditCart = () => {
  const {
    accountId,
    hasBeenAddedNewCard,
    dueDate,
    cardNumber,
    validationCode,
    holderName,
    bin,
    creditCard,
    cpf,
    installmentsSelected,
  } = useContext(CreditCardContext)

  return {
    accountId,
    hasBeenAddedNewCard,
    dueDate,
    cardNumber,
    validationCode,
    holderName,
    bin,
    creditCard,
    cpf,
    installmentsSelected,
  }
}
